enum Browsers {
    CHROME = 'CHROME',
    SAFARI = 'SAFARI',
    FIREFOX = 'FIREFOX',
    INTERNET_EXPLORER = 'INTERNET_EXPLORER',
    EDGE = 'EDGE',
    OPERA = 'OPERA',
    UNKNOWN = 'UNKNOWN'
}

export default Browsers;